import React, {useEffect} from 'react'
import Banner from '../../Components/Banner'
import ReviewBox from '../../Components/ReviewBox'
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import{ init, send } from 'emailjs-com';
import emailkey from '../../emailkey';

function Contact() {
    const { t } = useTranslation();
    const data = {
        title: t('main.getInTouch'),
        description: t('main.getInTouchDesc'),
        navigation : [{path: '/contact', title: t('main.contact')}]
    }

    function submitReview (name: string, email: string, text : string) {
        let message = {name, email, text}
        init(emailkey.USER_ID);
        send(emailkey.SERVICE_ID, emailkey.TEMPLATE_ID, message, emailkey.USER_ID)
        .then((result: any) => {
            console.log("Message Sent, We will get back to you shortly", result.text);
        },
        (error: any) => {
            console.log("An error occurred, Please try again", error.text);
        });
    }

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return(
        <>
            <Banner data={data}/>
            {/* <!-- contact --> */}
            <section className="knsl-p-100-100">

            <div id="knsl-triger-1"></div>

            <div className="container">

                {/* <!-- features card --> */}
                <div className="knsl-features-card">

                <div className="row">
                    <div className="col-12 col-lg-4">

                    {/* <!-- icon box --> */}
                    <div className="knsl-icon-box">
                        <img src="assets/img/features/9.svg" alt="icon" className="knsl-mb-10" />
                        <h5 className="knsl-mb-10">{t('main.welcomes')}</h5>
                        <p>{t('main.ourAddress')}</p>
                    </div>
                    {/* <!-- icon box end --> */}

                    </div>
                    <div className="col-12 col-lg-4">

                    {/* <!-- icon box --> */}
                    <div className="knsl-icon-box">
                        <img src="assets/img/features/10.svg" alt="icon" className="knsl-mb-10" />
                        <h5 className="knsl-mb-10">{t('main.call')}</h5>
                        <p>(+237) 694 879 417/679 298 609</p>
                    </div>
                    {/* <!-- icon box end --> */}

                    </div>
                    <div className="col-12 col-lg-4">

                    {/* <!-- icon box --> */}
                    <div className="knsl-icon-box">
                        <img src="assets/img/features/11.svg" alt="icon" className="knsl-mb-10" />
                        <h5 className="knsl-mb-10">{t('main.write')}</h5>
                        <p>contact@westheaven-hotel.com</p>
                    </div>
                    {/* <!-- icon box end --> */}

                    </div>
                </div>

                </div>

            </div>
            </section>
            {/* <!-- contact end --> */}


            <section className="knsl-transition-top knsl-p-0-100">
                <img src="assets/img/palm.svg" className="knsl-deco-left" alt="palm" />
                <img src="assets/img/palm.svg" className="knsl-deco-right" alt="palm"/>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">

                            <div className="knsl-center knsl-title-frame knsl-scroll-animation knsl-mb-100">
                                <h2 className="knsl-mb-20">{t('main.waitingForYou')}</h2>
                                <p className="knsl-mb-30">{t('main.waitingForYouDesc')}</p>
                                <Link to="/about" className="knsl-btn knsl-btn-md">{t('main.moreAbout')}</Link>
                            </div>

                        </div>
                    </div>
                    <ReviewBox onSubmit={submitReview} end="message" />
                </div>
            </section>
        </>
    )
}

export default Contact as React.FC
